module.exports = __webpack_public_path__ + "img/active-downArrow.1245fc19.svg";